export function updateGoldResult(banner_rupees, goldRate) {
  var goldInGrams = 0;
  if (banner_rupees > 9999999) {
    banner_rupees = 9999999;
  }

  if (!isNaN(banner_rupees) && banner_rupees > 0) {
    goldInGrams = (banner_rupees / goldRate).toFixed(2);
    return goldInGrams;
  } else {
    return goldInGrams;
  }
}

export function updateRupeesResult(grams, goldRate) {
  var bannerRupees = 0;
  if (grams > 9999999) {
    grams = 9999999;
  }

  if (!isNaN(grams) && grams > 0) {
    bannerRupees = (grams * goldRate).toFixed(2);
    return bannerRupees;
  } else {
    return bannerRupees;
  }
}
